import { useAuth } from '@verantos-dev/core-annotation-tool';
import { useFeatureFlagSplit } from '@verantos-dev/core-utils';

import { TRIGGER_ACCURACY_FROM_UI_FF } from '../constants';

/**
 * Single flag + role predicate, called from every gated surface (menu item, route)
 * so the two-term condition can't drift between call sites.
 *
 * `useFeatureFlagSplit` reads `false` until the Split SDK is ready and permanently
 * `false` under `VITE_BYPASS_SPLIT=true` — see the design doc's Release and risk
 * section for why the route must not depend on this via a redirect wrapper.
 */
// TODO: cleanup with cp_trigger_accuracy_from_ui ff
export const useCanGenerateAccuracy = (): boolean => {
  const isFlagOn = useFeatureFlagSplit(TRIGGER_ACCURACY_FROM_UI_FF);
  const { user } = useAuth();
  return Boolean(isFlagOn) && user.isAdmin;
};
